// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EVsc","content":"styles_content__3n7Nd"};